import { render, staticRenderFns } from "./BackupSchedule.vue?vue&type=template&id=5979e07f&scoped=true&"
import script from "./BackupSchedule.vue?vue&type=script&lang=js&"
export * from "./BackupSchedule.vue?vue&type=script&lang=js&"
import style0 from "./BackupSchedule.vue?vue&type=style&index=0&id=5979e07f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5979e07f",
  null
  
)

export default component.exports